import { FC } from 'react';

import { t } from '@onlinepayments/payments-library';

import OpeningHour from '../../interfaces/OpeningHour';

import OpeningHoursItem from './OpeningHoursItem';

interface IOpeningHoursProps {
  openingHours: OpeningHour[];
}

const OpeningHoursComponent: FC<IOpeningHoursProps> = ({ openingHours }) => {
  const [mon, tue, wed, thu, fri, sat, sun] = openingHours;

  function monToFriHasSameOpeningHours() {
    return (
      mon.span === tue.span &&
      tue.span === wed.span &&
      wed.span === thu.span &&
      thu.span === fri.span
    );
  }

  function monToSunHasSameOpeningHours() {
    return (
      mon.span === tue.span &&
      tue.span === wed.span &&
      wed.span === thu.span &&
      thu.span === fri.span &&
      fri.span === sat.span &&
      sat.span === sun.span
    );
  }

  function renderOpeningHours() {
    if (monToSunHasSameOpeningHours()) {
      return (
        <div>
          <OpeningHoursItem
            span={mon.span}
            dayText={`${t('day_of_week_short_monday')} - ${t('day_of_week_short_sunday')}`}
          />
        </div>
      );
    } else if (monToFriHasSameOpeningHours()) {
      return (
        <div>
          <OpeningHoursItem
            span={mon.span}
            dayText={`${t('day_of_week_short_monday')} - ${t('day_of_week_short_friday')}`}
          />
          <OpeningHoursItem span={sat.span} dayText={t('day_of_week_short_saturday')} />
          <OpeningHoursItem span={sun.span} dayText={t('day_of_week_short_sunday')} />
        </div>
      );
    } else {
      return (
        <div>
          <OpeningHoursItem span={mon.span} dayText={t('day_of_week_short_monday')} />
          <OpeningHoursItem span={tue.span} dayText={t('day_of_week_short_tuesday')} />
          <OpeningHoursItem span={wed.span} dayText={t('day_of_week_short_wednesday')} />
          <OpeningHoursItem span={thu.span} dayText={t('day_of_week_short_thursday')} />
          <OpeningHoursItem span={fri.span} dayText={t('day_of_week_short_friday')} />
          <OpeningHoursItem span={sat.span} dayText={t('day_of_week_short_saturday')} />
          <OpeningHoursItem span={sun.span} dayText={t('day_of_week_short_sunday')} />
        </div>
      );
    }
  }

  return (
    <div className="OpeningHoursComponent w-3/5 mt-150" data-testid="OpeningHours">
      {renderOpeningHours()}
    </div>
  );
};

export default OpeningHoursComponent;
